import { useFetch } from '../api/fetch/useFetch'
import { useSessionStore } from '@/entities/Session/model'
import { ensureValidToken } from '@/shared/lib/auth/tokenManager'

// type RequestMethod = 'GET' | 'POST' | 'PUT' | 'DELETE'

interface CreateRepositoryOptions {
  basePath: string
  useAuth?: boolean
}

export function createRepository({ basePath, useAuth = false }: CreateRepositoryOptions) {
  const getToken = async (): Promise<string | undefined> => {
    if (!useAuth) return undefined
    
    // Проверяем и обновляем токен при необходимости
    const isValid = await ensureValidToken()
    if (!isValid) return undefined
    
    const session = useSessionStore()
    return session.token ?? undefined
  }

  async function get<TResponse, TParams = undefined>(
    path: string,
    params: TParams | undefined = undefined,
    errors: Record<number, string> = {},
    adapter?: (data: any) => TResponse
  ) {
    const token = await getToken()
    return useFetch<TResponse, TParams>({
      method: 'GET',
      resource: `${basePath}${path}`,
      body: params,
      token,
      errors,
      adapter
    })
  }

  async function post<TResponse, TBody = undefined>(
    path: string,
    body: TBody | undefined = undefined,
    errors: Record<number, string> = {},
    adapter?: (data: any) => TResponse
  ) {
    const token = await getToken()
    return useFetch<TResponse, TBody>({
      method: 'POST',
      resource: `${basePath}${path}`,
      body,
      token,
      errors,
      adapter
    })
  }

  async function put<TResponse, TBody = undefined>(
    path: string,
    body: TBody | undefined = undefined,
    errors: Record<number, string> = {},
    adapter?: (data: any) => TResponse
  ) {
    const token = await getToken()
    return useFetch<TResponse, TBody>({
      method: 'PUT',
      resource: `${basePath}${path}`,
      body,
      token,
      errors,
      adapter
    })
  }

  async function del<TResponse, TParams = undefined>(
    path: string,
    params: TParams | undefined = undefined,
    errors: Record<number, string> = {},
    adapter?: (data: any) => TResponse
  ) {
    const token = await getToken()
    return useFetch<TResponse, TParams>({
      method: 'DELETE',
      resource: `${basePath}${path}`,
      body: params,
      token,
      errors,
      adapter
    })
  }

  return {
    get,
    post,
    put,
    del
  }
}
